import {
  EDIT_MERCHANT_FAILD,
  EDIT_MERCHANT_LOADING,
  EDIT_MERCHANT_SUCCESS,
  REMOVE_EDIT_MERCHANT,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  status: null,
};

export const editMerchantReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case EDIT_MERCHANT_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
        status: null,
      };
    case EDIT_MERCHANT_SUCCESS:
      return {
        ...state,
        loading: false,
        status: action.payload,
      };
    case EDIT_MERCHANT_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
        status: null,
      };
    case REMOVE_EDIT_MERCHANT:
      return initialState
    default:
      return state;
  }
};
